import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Timesheet } from './timesheet.model';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe, formatDate } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {  MomentDateAdapter } from '@angular/material-moment-adapter';
import { TimesheetListComponent } from '../timesheet-list/timesheet-list.component';
import { CategoryService } from '../../services/category.service';
import { ActivityService } from '../../services/acitvity.service';
import moment from 'moment';
import { TimesheetService } from '../../services/timesheet.service';
import type { ResponseBase } from '../../constant/response';
import { Category } from '../../dtos/Category';
import { ResponseCommonForList } from '../../dtos/ResponseDTOs';
import { Activity } from '../../dtos/Activity';
import { SingleSelectSearch } from '../../helper/SingleSelectSearch';
import { IdName } from '../../dtos/IdName';
import { RoleEnum } from '../../enums/role.enum';

const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

function maxTwoDecimalPlaces(control: AbstractControl): { [key: string]: any } | null {
  const value = control.value;
  if (value !== null && value !== undefined && !/^\d+(\.\d{1,2})?$/.test(value.toString())) {
    return { 'maxTwoDecimalPlaces': true };
  }
  return null;
}

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.css'],
  standalone: false,
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class TimesheetComponent implements OnInit {

  timesheetForm: FormGroup;
  filterForm: FormGroup;
  timesheets: Timesheet[] = [];
  submittedSuccessfully = false;
  currentPage = 0;
  pageSize = 10;

  @ViewChild(TimesheetListComponent) timeSheetListCompo : any;
  totalItemsCount: any;
  userData:any
  isAdmin: boolean=false;
  isTeamlead: boolean = false;
  categoryList: Category[] = [];
  activityList: Activity[] = [];
  isExcelExporting: boolean = false;
  exportButtonText: string = 'Export Timesheet';
  today : Date = new Date();
  minDate : Date = new Date();


  categorySearch: SingleSelectSearch<IdName>;
  activitySearch: SingleSelectSearch<IdName>;


  constructor(
    private categoryService: CategoryService,
    private activityService: ActivityService,
    private formBuilder: FormBuilder,
    private timesheetService: TimesheetService,
    private snackBar: MatSnackBar,
    public datePipe: DatePipe,
    private dateAdapter: DateAdapter<any>
  ) {
    this.dateAdapter.setLocale('en-GB');

    this.timesheetForm = this.formBuilder.group({
      workDate: [moment(), Validators.required],
      categoryId: ['', Validators.required],
      activityId: ['', Validators.required],
      noOfHours: ['', [Validators.required,Validators.max(10), maxTwoDecimalPlaces]],
      workDone: [''],
      // startTime: [''], 
      // endTime: [''], 
      userId:['']
    });

    this.categorySearch = new SingleSelectSearch<IdName>([]);
    this.activitySearch = new SingleSelectSearch<IdName>([]);

    this.filterForm = this.formBuilder.group({
      workDoneFilter: [''],
      startDate: [''],
      endDate: [''],
      startTimeFilter: [''],
      endTimeFilter: [''],
    });
  }

  ngOnInit(): void {
    this.getStorageData();
    this.getAllCategory();
    this.filterDate();
  }

  day = this.minDate.getDay();


  filterDate() : void {
    if(this.day <= 3 ) {
      this.minDate.setDate(this.today.getDate() - 4);
    } else {
      this.minDate.setDate(this.today.getDate() - 3);
    }
  }

  getAllCategory(): void {
      this.categoryService.getAllCategory().subscribe({
        next: (res: ResponseCommonForList<Category>) => {
          this.categoryList = res.responseObject;
          this.categorySearch.setOptions(this.categoryList.map((c: Category) => ({ id: c.id, name: c.name })));
        },
        error: (err: HttpErrorResponse) => {
          console.error("Error getting List of Category", err.message);
        }
      });
    }

  exportTimesheet(){
    this.timeSheetListCompo.exportTimesheet();
  }

  getStorageData(){
    let user:any = sessionStorage.getItem("userData")
    let authToken = sessionStorage.getItem("authToken");

    this.userData = JSON.parse(user)


    if(this.userData){
      this.timesheetForm.get("userId")?.setValue(this.userData.id)
    }
    this.isAdmin = this.userData.roleId == RoleEnum.ADMIN;
    this.isTeamlead = this.userData.roleId == RoleEnum.TEAMLEAD;
  }

  isSubmitting = false;
 onSubmit(): void {

  if (this.isSubmitting) return;
  if (this.isAdmin) {
    this.snackBar.open('Admin cannot create timesheet.', 'Close', { duration: 3000 });
    return;
  }

  if (this.timesheetForm.get("userId")?.value == null) {
    this.timesheetForm.get("userId")?.setValue(this.userData.id);
  }


  const categoryId = this.timesheetForm.get('categoryId')?.value;
  const activityId = this.timesheetForm.get('activityId')?.value;
  const workDone = this.timesheetForm.get('workDone')?.value;
  const noOfHours = this.timesheetForm.get('noOfHours')?.value;

  if (!categoryId) {
    this.snackBar.open('Category is required.', 'Close', { duration: 3000 });
    return;
  }

  if (!activityId) {
    this.snackBar.open('Activity is required.', 'Close', { duration: 3000 });
    return;
  }

  if(!noOfHours){
    this.snackBar.open('Number Of Hours is required.', 'Close', { duration: 3000 });
    return;
  }

  // if (!workDone || workDone.trim() === '') {
  //   this.snackBar.open('Description (Work Done) is required.', 'Close', { duration: 3000 });
  //   return;
  // }
 
  if (this.timesheetForm.valid) {

    this.isSubmitting = true;
    const timesheetData: Timesheet = { ...this.timesheetForm.value };

    const workDateValue: Date | null = this.timesheetForm.get('workDate')?.value;
    if (workDateValue) {
      timesheetData.workDate = new Date(formatDate(workDateValue, 'yyyy-MM-dd', 'en'));
    }

    this.timesheetService.createTimesheet(timesheetData).subscribe({
      next: (res: ResponseBase<Timesheet>) => {

        this.snackBar.open(res.message, 'Close', { duration: 3000 });

        this.submittedSuccessfully = true;

        this.timesheetForm.reset({
          categoryId: '',
          activityId: '',
          noOfHours: '',
          userId: null,
          workDone: '',
          workDate: moment()
        });

        this.activityList = [];
        this.clearErrorStates();
        this.timeSheetListCompo.getTimesheets();
        this.isSubmitting = false;
      },
      error: (error: HttpErrorResponse) =>
        this.handleError(error, 'Failed to submit timesheet')
    });

  } else {
    this.snackBar.open('Please fill all required fields.', 'Close', { duration: 3000 });
  }
}
  onCategorySelection(id:any) {
    let type = this.categoryList.find(category => category.id == id)?.categoryTypeId ?? 0;
    this.getActivityListByCategoryType(type);
  }


  getActivityListByCategoryType(categoryTypeId: number): void {
    this.activityService.getActivityByCategoryTypeId(categoryTypeId).subscribe({
      next: (res: ResponseCommonForList<Activity>) => {
        this.activityList = res.responseObject;
        this.activitySearch.setOptions(this.activityList.map((a: Activity) => ({id: a.id, name: a.name})));
        if(this.activityList.length == 1 && this.timesheetForm.get('categoryId')?.value != null) {
          this.timesheetForm.get('activityId')?.setValue(this.activityList[0].id);
        } else {
          this.timesheetForm.get('activityId')?.reset();
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting Activities By CategoryTypeId:", err.message);
      }
    });
  }

  onFilter(): void {
    const filterData = this.filterForm.value;
    filterData.startDate = this.datePipe.transform(filterData.startDate, 'yyyy-MM-dd');
    filterData.endDate = this.datePipe.transform(filterData.endDate, 'yyyy-MM-dd');
  }

  private handleError(error: HttpErrorResponse, message: string): void {
    this.snackBar.open(`${message}. Please try again.`, 'Close', { duration: 3000 });
  }

  private clearErrorStates(): void {
    const formControls = ['workDate','categoryId','activityId','workDone', 'noOfHours'];
    formControls.forEach(controlName => {
      const control = this.timesheetForm.get(controlName);
      if (control) {
        control.setErrors(null);
      }
    });
  }

  private formatTime(time: string): string {
    const timeParts = time.split(':');
    if (timeParts.length === 2) {
      return `${timeParts[0].padStart(2, '0')}:${timeParts[1].padStart(2, '0')}:00`;
    } else {
      return time;
    }
  }

  excelExportButtonStatus(value:any){
    this.isExcelExporting = value;
    if(value){
      this.exportButtonText = 'Exporting... ';
    }else{
      this.exportButtonText = 'Export Timesheet';
    }
  }
}
